import { GetCommentAutoReplyConditionResponse } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_CONDITION_V2 } from '../apis';

const defaultData = {
  id: '',
  name: '',
  replyTo: 1,
  replyContentType: 1,
  publicReplyContent: [''],
  condition: [],
  postType: 1,
} as GetCommentAutoReplyConditionResponse;

async function getCommentReplyCondition(id: string) {
  return axios
    .get(`${COMMENT_REPLY_CONDITION_V2}?id=${id}`)
    .then((res) => res.data.data)
    .catch((err) => {
      return defaultData;
    });
}

export function useGetCommentReplyConditionV2(id: string) {
  return useQuery<GetCommentAutoReplyConditionResponse>({
    queryKey: ['get-comment-reply-condition-v2', { id }],
    queryFn: () => {
      if (id) {
        return getCommentReplyCondition(id);
      } else {
        return defaultData;
      }
    },
  });
}
